import UserForm from "@/components/forms/UserForm";
import React from "react";

const NewUserPage = () => {
  return <UserForm />;
};

export default NewUserPage;
